import { ChangeEvent, FC, useState, useMemo, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useQuery } from 'react-query';
import { Grid, Paper, Tabs, Tab, Box } from '@material-ui/core';
import { GridColumns, GridCellParams, DataGrid } from '@material-ui/data-grid';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import EmailIcon from '../../../assets/icons/EndUser/Email.svg';
import { getRowsPerPageOptions } from 'utils/pagination';
import { Search } from 'components/Search';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { Button, MenuItem } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PersonIcon from '@material-ui/icons/Person';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { ConfirmActionDialog } from 'components/Dialogs';
import { UserDepartmentData } from './types';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Tooltip } from '@material-ui/core';
import SyncIcon from '@mui/icons-material/Sync';
import SyncDisabledIcon from '@material-ui/icons/SyncDisabled';
import { green, red } from '@material-ui/core/colors';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import TabPanel from 'components/TabPanel';
import { Card, CardContent, Typography } from '@material-ui/core';
import GoogleSvg from '../../../assets/googlelogo.svg';
import GithubSvg from '../../../assets/GitHub-logo.png';
import Timeline from 'components/Timeline';
import { useLocation } from 'react-router-dom';
function useQuer() {
  return new URLSearchParams(useLocation().search);
}

export const DepartmentTable: FC<any> = observer(() => {
  const {
    departmentTableStore: { getManagerDepartment, getAppDepartment },
    departmentTableStore: {
      setFilter,
      getUserDepartment,
      userDepartmentsView,
      deleteDepartment,
      deleteManager,
      deleteApp,
    },
    endUserSettingsFormStore: { getPortalSettings },
    notificationStore: { openNotification },
    logsTableStore: { viewUser, viewEndUser },
    ldapStore: { getDepartmentTimeline },
    userStore: { user },
  } = useStore();
  const history = useHistory();
  const classes = useStyles();
  const query = useQuer();
  const queryValue = query.get('value');
  const defaultTabs = (Array.isArray(queryValue) ? queryValue[0] : queryValue) ?? 'one';
  const [value, setValue] = useState(defaultTabs);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setValue(params.get('value') || 'one');
  }, [location.search]);

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);

    if (newValue === 'one') {
      history.replace(location.pathname);
    } else {
      history.replace(`${location.pathname}?value=${newValue}`);
    }
  };
  const [openAdd, setOpenAdd] = useState(false);
  const handleClickAwayAdd = () => {
    setOpenAdd(false);
  };
  const handleClickAdd = () => {
    setOpenAdd((prev) => !prev);
  };
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [deleteItemDn, setDeleteItemDn] = useState<string>('');
  const [currentDepartment] = useState<any>(JSON.parse(localStorage.getItem('CurrentDepartment') as string));
  const [deleteItemMail, setDeleteItemMail] = useState<string>('');
  const [deleteItemValue, setDeleteItemValue] = useState<string>('');
  const [processedRows, setProcessedRows] = useState<any[]>([]);
  const [selectedManager, setSelectedManager] = useState<UserDepartmentData | null>(null);
  const [openManagerDialog, setOpenManagerDialog] = useState(false);
  const getClickedUser = useMutation(
    'viewUser',
    (ClientId: number) => (user?.permission !== 'EndUser' ? viewUser(ClientId) : viewEndUser(ClientId)),
    {
      onSuccess: (user) => {
        let url;
        if (user?.data?.message === 'End User Group and Department') {
          url = `${handleCompanyUrl('/admin/profile')}`;
          window.open(url, '_blank');
        }
        localStorage.setItem('ClickedUser', JSON.stringify(user.data.user));
        if (user?.data?.message === 'User found') {
          url = `${handleCompanyUrl('/user/view')}`;
          window.open(url, '_blank');
        } else {
          url = `${handleCompanyUrl('/admin/profile')}`;
          window.open(url, '_blank');
        }
        window.open(url, '_blank');
      },
      onError: (error: any) => {
        openNotification('error', error.data?.message || error.message || 'User not found');
      },
    }
  );

  const timelineReq = useQuery(
    ['departmentTimeline', currentDepartment?.ou],
    () => getDepartmentTimeline(currentDepartment?.ou || ''),
    {
      enabled: value === 'four',
      refetchOnWindowFocus: false,
      staleTime: 0,
    }
  );

  useEffect(() => {
    if (value === 'four') {
      timelineReq.refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const getUserDepartmentReq = useQuery('getUserDepartment', () => getUserDepartment(currentDepartment?.dn), {
    enabled: value === 'one',
    onError: (error: Error) => openNotification('error', error.message),
  });

  const getManagerDepartmentReq = useQuery('getManagerDepartment', () => getManagerDepartment(currentDepartment?.dn), {
    enabled: value === 'two',
    onError: (error: Error) => openNotification('error', error.message),
  });

  const getAppDepartmentReq = useQuery('getAppDepartment', () => getAppDepartment(currentDepartment?.department_id), {
    enabled: value === 'three',
    onError: (error: Error) => {
      openNotification('error', error.message);
    },
  });
  const deleteDepartmentReq = useMutation((data: UserDepartmentData) => deleteDepartment(data, currentDepartment?.dn), {
    mutationKey: 'deleteDepartmentReq',
    onSuccess: () => {
      openNotification('success', 'Remove Successfully');
      getUserDepartmentReq.refetch();
    },
    onError: () => openNotification('error', `Can't Remove User`),
  });

  const deleteManagerReq = useMutation((data: UserDepartmentData) => deleteManager(data), {
    mutationKey: 'deleteManagerReq',
    onSuccess: () => {
      openNotification('success', 'Remove Successfully');
      getManagerDepartmentReq.refetch();
    },
    onError: () => openNotification('error', `Can't Remove Manager`),
  });

  const deleteAppReq = useMutation((data: { department_id: number; provider: string }) => deleteApp(data), {
    onSuccess: async () => {
      openNotification('success', 'Deleted successfully');
      getAppDepartmentReq.refetch();
    },
    onError: (error: any) => openNotification('error', error?.message || 'Delete failed'),
  });

  const handleDelete = (provider: string) => {
    deleteAppReq.mutate({
      department_id: currentDepartment?.department_id,
      provider: provider,
    });
  };
  useQuery('portalSettingsgetReq', () => getPortalSettings(), {
    onError: () => openNotification('error', `Can't get data`),
  });

  const endUserConfigSettings = JSON.parse(localStorage.getItem('endUserConfigSettings') as string);
  const userId = endUserConfigSettings?.userId;
  const rows = useMemo(() => {
    return !getUserDepartmentReq.isFetching ? userDepartmentsView : [];
  }, [getUserDepartmentReq.isFetching, userDepartmentsView]);
  const [pageSize, setPageSize] = useState(10);
  const rowsPerPageOptions = useMemo(() => getRowsPerPageOptions(rows), [rows]);
  const columns: GridColumns = [
    {
      field: 'icon',
      headerName: ' ',
      width: 40,
      align: 'center',
      disableColumnMenu: true,
      renderCell: (params: GridCellParams) => <PersonIcon style={{ color: 'grey' }} />,
    },
    // { field: 'sn', headerName: 'LAST', flex: 0.5 },
    // { field: 'givenname', headerName: 'FIRST', flex: 0.5 },

    {
      field: 'name',
      headerName: 'FULL NAME',
      flex: 0.8,
      renderCell: (params: GridCellParams) => (
        <Tooltip title={(params.row.givenname || '') + ' ' + (params.row.sn || '')}>
          <div>
            <span>
              {params.row.givenname} {params.row.sn}
            </span>
          </div>
        </Tooltip>
      ),
    },
    {
      field: 'uid',
      headerName: endUserConfigSettings?.userId === null || endUserConfigSettings?.userId === '' ? 'UID' : userId,
      flex: 1,
      renderCell: (params: GridCellParams) => {
        const value = String(params.value ?? '');

        return (
          <div
            style={{
              cursor: 'pointer',
              color: '#1976d2',
              textDecoration: 'underline',
            }}
            onClick={(event) => {
              const id = params.row.memberuid || params.row.dn || params.row.uid;
              event.stopPropagation();
              getClickedUser.mutate(id);
            }}
          >
            {value}
          </div>
        );
      },
    },

    {
      field: 'mail',
      headerName: 'EMAIL',
      flex: 1,
      renderCell: (params: GridCellParams) => {
        const value = String(params.value ?? '');

        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            <img src={EmailIcon} alt='' />
            <span>{value}</span>
          </div>
        );
      },
    },

    {
      field: 'syncDepartment',
      headerName: 'SYNC',
      flex: 1,
      renderCell: (params: GridCellParams) => {
        return params.row.isSynced ? (
          <SyncIcon style={{ color: green[500] }} />
        ) : (
          <SyncDisabledIcon style={{ color: red[500] }} />
        );
      },
    },
    {
      field: 'actions',
      headerName: 'ACTIONS',
      width: 160,
      disableColumnMenu: true,
      renderCell: (params: GridCellParams) => (
        <>
          <Tooltip title='Delete User from Department'>
            <IconButton
              size='small'
              onClick={() => {
                setDeleteItemDn(params.row.dn as string);
                setDeleteItemMail(params.row.mail as string);
                setOpenConfirmDialog(true);
              }}
            >
              <DeleteIcon style={{ fill: '#F44336' }} />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];
  useEffect(() => {
    const updatedRows = rows.map((item) => {
      let syncDepartmentGoogleArray: string[] = [];
      if (item.syncDepartment && item.syncDepartment !== 'null') {
        try {
          const syncDepartment = JSON.parse(item.syncDepartment);
          syncDepartmentGoogleArray = syncDepartment.google || [];
        } catch (error) {
          console.error('Error parsing syncDepartment:', error);
        }
      }
      const currentDepartmentDn = currentDepartment?.dn.toLowerCase().trim();
      const isMatch = syncDepartmentGoogleArray.some(
        (value: string) => value.trim().toLowerCase() === currentDepartmentDn
      );
      return {
        ...item,
        isSynced: isMatch,
      };
    });
    setProcessedRows(updatedRows);
    // const anyUnsynced = updatedRows.some((row) => !row.isSynced);
    // setShowSyncMessage(anyUnsynced);
  }, [rows, currentDepartment]);
  useAppPreloader(
    getUserDepartmentReq.isFetching ||
      deleteDepartmentReq.isLoading ||
      getManagerDepartmentReq.isFetching ||
      deleteManagerReq.isLoading ||
      getAppDepartmentReq.isFetching
  );
  return (
    <>
      <Grid container alignItems='center' className={classes.box}>
        <IconButton
          onClick={() => {
            history.push(handleCompanyUrl('/departments'));
          }}
        >
          <ChevronLeftIcon />
        </IconButton>
        <h1>Department: {currentDepartment?.ou}</h1>
      </Grid>

      <Tabs
        value={value}
        className={classes.tabs}
        TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
        onChange={handleChange}
      >
        <Tab value='one' label={`Users`} className={classes.label} />
        <Tab value='two' label={`Managers`} />
        <Tab value='three' label={`Apps`} />
        <Tab value='four' label={`Timeline`} />
      </Tabs>

      <TabPanel value={value} index='one'>
        <>
          <Grid container justify='space-between' alignItems='center' className={classes.box}>
            <Search handelSearch={setFilter} />
            <ClickAwayListener onClickAway={handleClickAwayAdd}>
              <div className={classes.root}>
                <Button
                  size='small'
                  variant='contained'
                  color='secondary'
                  className={classes.btnAdd}
                  onClick={handleClickAdd}
                >
                  <AddCircleOutlineIcon />
                </Button>
                {openAdd ? (
                  <div className={classes.dropdown}>
                    <MenuItem
                      className={classes.selectItem}
                      onClick={() => history.push(handleCompanyUrl('/department/add-users'))}
                    >
                      <PersonIcon style={{ color: 'grey' }} /> Add New Users to Department
                    </MenuItem>
                  </div>
                ) : null}
              </div>
            </ClickAwayListener>
          </Grid>
          {getUserDepartmentReq.isFetching === false && (
            <>
              {rows.length === 0 ? (
                <h1 className={classes.link}> This department has no users associated with it. </h1>
              ) : (
                <Paper className={classes.dataGrid} elevation={0}>
                  <DataGrid
                    className={classes.noBorder}
                    autoHeight
                    rows={processedRows}
                    columns={columns}
                    pageSize={pageSize}
                    rowsPerPageOptions={rowsPerPageOptions}
                    pagination
                    onPageChange={(params) => setPageSize(params.pageSize)}
                  />
                </Paper>
              )}
            </>
          )}
        </>
      </TabPanel>
      <TabPanel value={value} index='two'>
        <Grid container justify='space-between' alignItems='center' className={classes.box}>
          <Search handelSearch={setFilter} />
          <ClickAwayListener onClickAway={handleClickAwayAdd}>
            <div className={classes.root}>
              <Button
                size='small'
                variant='contained'
                color='secondary'
                className={classes.btnAdd}
                onClick={handleClickAdd}
              >
                <AddCircleOutlineIcon />
              </Button>
              {openAdd ? (
                <div className={classes.dropdown}>
                  <MenuItem
                    className={classes.selectItem}
                    onClick={() => history.push(handleCompanyUrl('/department/add-managers'))}
                  >
                    <PersonIcon style={{ color: 'grey' }} /> Add New Managers to Department
                  </MenuItem>
                </div>
              ) : null}
            </div>
          </ClickAwayListener>
        </Grid>
        {getManagerDepartmentReq?.isFetching === false && (
          <>
            {getManagerDepartmentReq?.data && getManagerDepartmentReq?.data.length > 0 ? (
              <DataGrid
                className={classes.noBorder}
                autoHeight
                rows={getManagerDepartmentReq.data?.map((manager: any, index: number) => ({
                  id: index,
                  name:
                    typeof manager === 'object'
                      ? manager.firstName && manager.secondName
                        ? `${manager.firstName} ${manager.secondName}`
                        : manager.firstName || 'Unknown'
                      : manager,
                  email: typeof manager === 'object' ? manager.email : '',
                  managerId: typeof manager === 'object' ? manager.user_id || manager.id : null,
                }))}
                columns={[
                  {
                    field: 'icon',
                    headerName: ' ',
                    width: 40,
                    disableColumnMenu: true,
                    renderCell: () => <SupervisorAccountIcon style={{ color: 'grey' }} />,
                  },
                  { field: 'name', headerName: 'NAME', flex: 1 },
                  {
                    field: 'email',
                    headerName: 'EMAIL',
                    flex: 1,
                    renderCell: (params: GridCellParams) => {
                      const value = String(params.value ?? '');

                      return (
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <img src={EmailIcon} alt='' />
                          <span>{value}</span>
                        </div>
                      );
                    },
                  },

                  // {
                  //   field: 'email',
                  //   headerName: 'EMAIL',
                  //   flex: 1,
                  //   renderCell: (params: GridCellParams) => (
                  //     <div style={{ display: 'flex', gap: '10px' }}>
                  //       <img src={EmailIcon} alt='' />
                  //       {params.value}
                  //     </div>
                  //   ),
                  // },
                  {
                    field: 'actions',
                    headerName: 'ACTIONS',
                    width: 160,
                    disableColumnMenu: true,
                    renderCell: (params: GridCellParams) => {
                      return (
                        <Tooltip title='Delete Manager From Group'>
                          <IconButton
                            size='small'
                            onClick={() => {
                              setSelectedManager({
                                department_id: params.row.department_id || currentDepartment?.department_id,
                                manager_id: params.row.managerId,
                              });

                              setOpenManagerDialog(true);
                            }}
                          >
                            <DeleteIcon style={{ fill: '#F44336' }} />
                          </IconButton>
                        </Tooltip>
                      );
                    },
                  },
                ]}
                pageSize={10}
                disableSelectionOnClick
              />
            ) : (
              <h1 className={classes.link}> No managers assigned to this department. </h1>
            )}
          </>
        )}
      </TabPanel>
      <TabPanel value={value} index='three'>
        <Grid container justify='flex-end' alignItems='center' className={classes.box}>
          <ClickAwayListener onClickAway={handleClickAwayAdd}>
            <div className={classes.root}>
              <Button
                size='small'
                variant='contained'
                color='secondary'
                className={classes.btnAdd}
                onClick={handleClickAdd}
              >
                <AddCircleOutlineIcon />
              </Button>
              {openAdd ? (
                <div className={classes.dropdown}>
                  <MenuItem
                    className={classes.selectItem}
                    onClick={() => history.push(handleCompanyUrl('/department/add-apps'))}
                  >
                    <PersonIcon style={{ color: 'grey' }} /> Add New Apps to Department
                  </MenuItem>
                </div>
              ) : null}
            </div>
          </ClickAwayListener>
        </Grid>
        <div className={classes.page}>
          {getAppDepartmentReq?.isFetching === false && (
            <>
              {getAppDepartmentReq?.data && getAppDepartmentReq?.data.length > 0 ? (
                <Grid container spacing={3}>
                  {getAppDepartmentReq?.data.map((app: string, index: number) => {
                    const getAppLogo = (appName: string) => {
                      switch (appName.toLowerCase()) {
                        case 'google':
                          return GoogleSvg;
                        case 'github':
                          return GithubSvg;
                        default:
                          return GoogleSvg;
                      }
                    };

                    const getCardClass = (appName: string) => {
                      let className = classes.card;
                      className += ` ${classes.approvedCard}`;
                      return className;
                    };

                    return (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card className={getCardClass(app)}>
                          <CardContent>
                            <DeleteIcon
                              className={`${classes.topIcon} ${classes.approvedIcon}`}
                              style={{
                                color: '#f44336',
                                fontSize: 28,
                                cursor: 'pointer',
                              }}
                              onClick={() => handleDelete(app)}
                            />
                            <div className={classes.appRow}>
                              <img src={getAppLogo(app)} alt={app} className={classes.appIcon} />
                              <Box>
                                <Typography className={classes.appName}>{app}</Typography>
                                <Typography className={classes.appDesc}>Access granted</Typography>
                              </Box>
                            </div>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })}
                </Grid>
              ) : (
                <h1 className={classes.link}> No apps connected to this department. </h1>
              )}
            </>
          )}
        </div>
      </TabPanel>
      <TabPanel value={value} index='four'>
        <Paper className={classes.dataGrid} elevation={0}>
          <Timeline header='departments' events={timelineReq.data} loading={timelineReq.isLoading} />
        </Paper>
      </TabPanel>
      <ConfirmActionDialog
        label='Remove User'
        buttonLabel='Confirm'
        gitStatus=''
        openModal={openConfirmDialog}
        action={() => {
          deleteDepartmentReq.mutate({
            uuid: deleteItemDn,
            userEmail: deleteItemMail,
            syncType: deleteItemValue,
          });
        }}
        handleClose={() => {
          setOpenConfirmDialog(false);
          setDeleteItemDn('');
          setDeleteItemMail('');
          setDeleteItemValue('');
        }}
      />

      <ConfirmActionDialog
        label='Remove Manager'
        buttonLabel='Confirm'
        openModal={openManagerDialog}
        action={() => {
          if (selectedManager) {
            deleteManagerReq.mutate(selectedManager);
          }
        }}
        gitStatus=''
        handleClose={() => {
          setOpenManagerDialog(false);
          setSelectedManager(null);
        }}
      />
    </>
  );
});
